define([
    "angular",
    "../autoRefresh/autoRefresh",
    "moment"
], function (angular) {
    "use strict";
    return angular.module("nlgHealthCheckerModule", [
        "autoRefreshModule"
    ]);
});